import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

export const environment: EnvironmentModel = {
  production: true,
  urls: { apiUrl: 'https://api.dashly.com' },
  sentryDSN: 'https://bd1aab99a16b44338ef222c2676f472c@sentry.io/1470764',
  googleCloudPlatformApiKey: 'AIzaSyCPNENGzQewO8-zubI6JB8fsoB2fxiS4O4',
  maintenanceUrl: 'https://storage.googleapis.com/dashlyprod-ui-apps-config/config.json',
  featureConfig: {
    [FeatureFlagEnum.AddSmartSearchForm]: false,
    [FeatureFlagEnum.MobileAppRedirect]: false,
  },
  companyAndNetworkIds: {
    dashlyCompanyId: '1',
    mabNetworkId: '1',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCCpj5Alqt7bB-YqUY7Z8bc72d5UsSfGaU',
    authDomain: 'dashlyprod.firebaseapp.com',
    databaseURL: 'https://dashlyprod.firebaseio.com',
    projectId: 'dashlyprod',
    storageBucket: 'dashlyprod.firebasestorage.app',
    messagingSenderId: '145867078999',
    appId: '1:145867078999:web:61a9b4c419371aa8c3d212',
    measurementId: 'G-VP6BLJEVL9',
  },
};
